import script from "./SwipeItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SwipeItem.vue?vue&type=script&setup=true&lang=js"

import "./SwipeItem.vue?vue&type=style&index=0&id=52173959&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52173959"]])

export default __exports__